class ComponentStickyAtc extends HTMLElement {
  connectedCallback() {
    this.init()
  }

  init() {
    const atcButtons =
      document.querySelector('#atc-wrapper') ||
      document
        .querySelector('hh-product-bundle-pdp')
        ?.shadowRoot?.querySelector('#purchase-controls')
    const ctaLinks =
      document.querySelector('#customAtc') ||
      document
        .querySelector('hh-product-bundle-pdp')
        ?.shadowRoot?.querySelector('#customAtc')
    const atcBtnContainer = this.dataset.link === 'true' ? ctaLinks : atcButtons
    if (atcBtnContainer) this.initStickyAtc(atcBtnContainer)

    let tries = 100
    if (!atcBtnContainer) {
      const interval = setInterval(() => {
        const buttons =
          document.querySelector('#atc-wrapper') ||
          document
            .querySelector('hh-product-bundle-pdp')
            ?.shadowRoot?.querySelector('#purchase-controls')
        const links =
          document.querySelector('#customAtc') ||
          document
            .querySelector('hh-product-bundle-pdp')
            ?.shadowRoot?.querySelector('#customAtc')
        const element = this.dataset.link === 'true' ? links : buttons
        tries -= 1
        if (element || tries <= 0) {
          clearInterval(interval)
          this.initStickyAtc(element)
        }
      }, 100)
    }
  }

  disconnectedCallback() {
    this.observer.disconnect()
    if (this.dataset.link === 'true') return
    this.removeEventListener('click', this.initAtcEvent.bind(this))
  }

  initStickyAtc(atcBtnContainer) {
    const options = {
      root: null,
      rootMargin: '-16px 0px -16px',
      threshold: [0, 1],
    }

    this.observer = new IntersectionObserver(
      this.showStickyAtc.bind(this),
      options
    )
    this.observer.observe(atcBtnContainer)
    if (this.dataset.link === 'true') return
    this.addEventListener('click', this.initAtcEvent.bind(this))
  }

  initAtcEvent() {
    const customEvent = new CustomEvent('sticky:atc', {})
    document.dispatchEvent(customEvent)
  }

  showStickyAtc(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting || entry.isVisible) {
        this.classList.remove('active')
        return
      }
      if (
        -entry.boundingClientRect.height > entry.boundingClientRect.top ||
        !entry.isVisible
      ) {
        this.classList.add('active')
      } else {
        this.classList.remove('active')
      }
    })
  }
}

customElements.define('pdp-sticky-atc', ComponentStickyAtc)
